import { Box, Typography } from "@mui/material";
import ParticipantContactStack from "./ParticipantContactStack";
import { AppointmentParticipant } from "./appointmentParticipantTypes";

type Props = {
  participants: AppointmentParticipant[];
  onViewMore: (participants: AppointmentParticipant[]) => void;
};

const ParticipantsCell = ({ participants, onViewMore }: Props) => {
  if (participants.length === 0) return <>-</>;

  if (participants.length <= 2) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        {participants.map((participant, index) => (
          <ParticipantContactStack key={index} participant={participant} />
        ))}
      </Box>
    );
  }

  const firstTwo = participants.slice(0, 2);
  const remaining = participants.length - 2;

  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        {firstTwo.map((participant, index) => (
          <ParticipantContactStack key={index} participant={participant} />
        ))}
      </Box>
      <Typography
        component="span"
        sx={{
          mt: 0.5,
          color: "primary.main",
          cursor: "pointer",
          fontWeight: 600,
          fontSize: "12px",
          textDecoration: "underline",
          display: "inline-block",
        }}
        onClick={() => onViewMore(participants)}
      >
        +{remaining} more
      </Typography>
    </Box>
  );
};

export default ParticipantsCell;
